// extracted by mini-css-extract-plugin
export default {"SortButton":"SortButton_SortButton__IGQt2","Arrow":"SortButton_Arrow__DmTEi","Sort":"SortButton_Sort__5GHNa"};